module.exports = __webpack_public_path__ + "static/screenshot5-ba099d9a5bf4ad5c55cd66ca4b0165dd.jpg";